/* eslint-disable jsx-a11y/alt-text */
import { Image, Link, Text, View } from '@react-pdf/renderer';

import { createPdfStyles } from '../utils/create-pdf-styles';

type SyllabusHeaderProps = {
  title: string;
};

const commonHeaderFooterStyles = {
  fontFamily: 'PolySans',
  backgroundColor: 'accent.sky.100',
  color: 'blue.800',
  width: '100%',
  height: 45,
  paddingHorizontal: '48px',
  paddingVertical: '12px',
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'space-between',
} as const;

const styles = createPdfStyles({
  header: {
    ...commonHeaderFooterStyles,
    marginBottom: '16px',
  },
  headerLogo: {
    width: '120px',
  },
  footer: {
    ...commonHeaderFooterStyles,
    height: '43px',
    position: 'absolute',
    bottom: 0,
    left: 0,
    right: 0,
  },
  title: {
    fontSize: '12px',
    textTransform: 'uppercase',
    letterSpacing: 1.25,
    fontWeight: 500,
    fontFamily: 'PolySans',
  },
  footerLogo: {
    width: '21.32px',
    height: '21.22px',
  },
  link: {
    fontFamily: 'PolySans',
    textTransform: 'uppercase',
    color: 'blue.800',
    textDecoration: 'none',
    letterSpacing: 1.5,
    fontSize: '11px',
    fontWeight: 600,
  },
});

export function SyllabusHeader(props: SyllabusHeaderProps) {
  const { title } = props;
  return (
    <View style={styles.header} fixed>
      <Text style={styles.title}>{title}</Text>
      <Image src='/images/logos/udacity-accenture-logo-colored.png' style={styles.headerLogo} />
    </View>
  );
}

export function SyllabusFooter() {
  return (
    <View style={styles.footer} fixed>
      <Image src='/images/logos/udacity-icon.png' style={styles.footerLogo} />
      <Link src='https://www.udacity.com' style={styles.link}>
        udacity.com
      </Link>
    </View>
  );
}
